import { render, staticRenderFns } from "./FormCreateAccess.vue?vue&type=template&id=011f47cb&"
import script from "./FormCreateAccess.vue?vue&type=script&lang=ts&"
export * from "./FormCreateAccess.vue?vue&type=script&lang=ts&"
import style0 from "./FormCreateAccess.vue?vue&type=style&index=0&id=011f47cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports